export const GET_TYPE_PICKING_ROUTE = 'GET_TYPE_PICKING_ROUTE'
export const GET_TYPE_PICKING_ROUTE_EXITO = 'GET_TYPE_PICKING_ROUTE_EXITO'
export const GET_TYPE_PICKING_ROUTE_ERROR = 'GET_TYPE_PICKING_ROUTE_ERROR'
